<script>
    export let link;
</script>

<a href={ link.url } target="_blank" rel="nofollow" class="link" style="--color-accent: {link.accent}">
    { #if link.iconClass }
        <i class={ link.iconClass }></i> 
    { /if }
    <span>{ link.title }</span>
</a>

<style lang="less">
    a {
        color: var(--color-350);
        display: inline-flex;
        margin-right: 15px;
        border: 1px solid var(--color-gray-300);
        border-radius: 300px;
        white-space: nowrap;
        align-items: center;
        flex-flow: row nowrap;
        overflow: hidden;
        transition: border-color .3s ease-out;

        @media screen and (min-width: 1025px) {
            &:hover {
                border-color: var(--color-accent);
                text-decoration: none;

                i {
                    background: var(--color-accent);
                }
            }
        }

        i {
            flex: 0 0 30px;
            height: 30px;
            border-radius: 50%;
            background: var(--color-gray-300);
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--color-white);
            transition: background .3s ease-out;
        }
        span {
            flex: 1 1 calc( ~"100% - 50px" );
            padding: 0 0 0 10px;
            display: flex;

            &:after {
                content: '';
                width: 30px;
                height: 1px;
            }
        }

        @media screen and (max-width: 1024px) {
            margin-top: 15px;
            border-color: var(--color-accent);

            i {
                background: var(--color-accent);
            }
        }
        @media screen and (max-width: 767px) {
            width: 100%;

            i {
                flex: 0 0 35px;
                height: 35px;
                font-size: 20px;
            }

            span {
                flex: 1 1 calc( ~"100% - 45px" );
                text-align: center;
                display: block;
                padding: 0 45px 0 0;
            }
        }
    }
</style>